// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qualita {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.anello {
  position: relative;
  flex: none;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.anello::before {
  content: "";
  position: absolute;
  inset: 12px;
  border-radius: 50%;
  background: var(--ion-card-background, var(--ion-background-color));
}
.anello span {
  position: relative;
  font-weight: 700;
  color: var(--ion-text-color);
}

.top-articoli {
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
  font-size: 0.8rem;
}
.top-articoli li {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: var(--ion-text-color);
}
.top-articoli b {
  color: var(--ion-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard-home/dashboard-qualita/dashboard-qualita.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,mEAAA;AACJ;AAEE;EACE,kBAAA;EACA,gBAAA;EACA,4BAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,4BAAA;AADJ;AAIE;EACE,8BAAA;AAFJ","sourcesContent":[".qualita {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.anello {\n  position: relative;\n  flex: none;\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::before {\n    content: '';\n    position: absolute;\n    inset: 12px;\n    border-radius: 50%;\n    background: var(--ion-card-background, var(--ion-background-color));\n  }\n\n  span {\n    position: relative;\n    font-weight: 700;\n    color: var(--ion-text-color);\n  }\n}\n\n.top-articoli {\n  margin: 10px 0 0;\n  padding: 0;\n  list-style: none;\n  font-size: 0.8rem;\n\n  li {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    color: var(--ion-text-color);\n  }\n\n  b {\n    color: var(--ion-color-danger);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
